class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.observer = null;
  }

  connectedCallback() {
    this.firstImage = this.querySelector('.product-image:first-child');
    this.lastImage = this.querySelector('.product-image:last-child');

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const available = entry.isIntersecting ? 'false' : 'true';
        if (entry.target === this.firstImage) {
          this.dataset.scrollUpAvailable = available;
        } else if (entry.target === this.lastImage) {
          this.dataset.scrollDownAvailable = available;
        }
      },
      {
        threshold: 1
      }
      )
    })

    if (this.firstImage) this.observer.observe(this.firstImage);
    if (this.lastImage) this.observer.observe(this.lastImage);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('product-media', ProductMedia);
